(function () {
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  document.addEventListener('DOMContentLoaded', function () {
    // ---- announcement: one message at a time on phones ----
    var msgs = qa('.oma-announce__list li');
    if (msgs.length > 1) {
      var m = 0;
      setInterval(function () {
        msgs[m].classList.remove('is-active');
        m = (m + 1) % msgs.length;
        msgs[m].classList.add('is-active');
      }, 3500);
    }

    // ---- today's date in the pulsing notice (the page may be cached) ----
    qa('[data-oma-date]').forEach(function (el) {
      var d = new Date();
      el.textContent = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
        'October', 'November', 'December'][d.getMonth()] + ' ' + d.getDate();
    });

    qa('[data-oma-date-long]').forEach(function (el) {
      var d = new Date();
      el.textContent = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][d.getDay()] + ', ' +
        ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
          'October', 'November', 'December'][d.getMonth()] + ' ' + d.getDate();
    });

    // ---- launch-price countdown: each new visitor starts a fresh timer at 14h and some minutes ----
    qa('[data-oma-countdown]').forEach(function (c) {
      var hrs = +c.getAttribute('data-hours') || 14, key = 'omaCountdownEnd', end = 0;
      var h = q('[data-cd="h"]', c), m = q('[data-cd="m"]', c), s = q('[data-cd="s"]', c);
      function fresh() { return Date.now() + (((hrs * 60) + 1 + Math.floor(Math.random() * 59)) * 60 + Math.floor(Math.random() * 60)) * 1000; }
      function save() { try { localStorage.setItem(key, end); } catch (e) {} }
      try { end = +localStorage.getItem(key) || 0; } catch (e) {}
      if (end < Date.now()) { end = fresh(); save(); }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { end = fresh(); save(); d = end - Date.now(); }
        h.textContent = pad(Math.floor(d / 3600000)); m.textContent = pad(Math.floor(d % 3600000 / 60000)); s.textContent = pad(Math.floor(d % 60000 / 1000));
      }
      tick(); setInterval(tick, 1000);
    });

    // ---- review slider arrows ----
    qa('[data-oma-slider]').forEach(function (w) {
      var track = q('.oma-testimonial__slider', w);
      q('.is-prev', w).addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.6, behavior: 'smooth' }); });
      q('.is-next', w).addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.6, behavior: 'smooth' }); });
    });

    // ---- gallery ----
    var slides = qa('[data-oma-slide]'), thumbs = qa('[data-oma-thumb]');
    var prevB = q('[data-oma-prev]'), nextB = q('[data-oma-next]'), cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach(function (s, j) { s.classList.toggle('is-active', cur === j); });
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', cur === j); });
      if (prevB) prevB.disabled = cur === 0;
      if (nextB) nextB.disabled = cur === slides.length - 1;
      if (thumbs[cur] && thumbs[cur].scrollIntoView) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    if (prevB) prevB.addEventListener('click', function () { show(cur - 1); });
    if (nextB) nextB.addEventListener('click', function () { show(cur + 1); });
    var mainBox = q('.oma-gallery__main'), sx = null, sy = null;
    if (mainBox) {
      mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // ---- buy now: one copy in the cart, then straight to checkout ----
    // Without JS the form still posts to /cart/add with return_to=/checkout.
    var form = q('#OmaForm');
    qa('.oma-header__cta').forEach(function (c) {
      c.addEventListener('click', function (e) { if (!form) return; e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var id = q('input[name="id"]', form).value, updates = {};
        updates[id] = 1;
        qa('button[type="submit"][form="OmaForm"], #OmaAtc').forEach(function (b) { b.disabled = true; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          window.location.href = '/checkout';
        }).catch(function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      });
      // Coming back from checkout with the Back button: make the buttons usable again
      window.addEventListener('pageshow', function () {
        qa('button[type="submit"][form="OmaForm"], #OmaAtc').forEach(function (b) { b.disabled = false; });
      });
    }

    // ---- sticky bar once the main button has scrolled away ----
    var atc = q('#OmaAtc'), sticky = q('#OmaSticky');
    if (atc && sticky) {
      var toggleSticky = function () { sticky.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', toggleSticky, { passive: true });
      toggleSticky();
    }
  });
})();
